import React from 'react';
import { motion } from 'framer-motion';
import { portfolioData } from '../data/mock';

const NovelsSection = () => {
  const { hobbies } = portfolioData;
  const { novels } = hobbies;
  
  return (
    <section className="py-16 sm:py-20 md:py-24 px-4 sm:px-6 md:px-12 lg:px-24 relative">
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {[...Array(15)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute"
            style={{ left: `${Math.random() * 100}%`, bottom: '-20px', width: '8px', height: '12px', background: 'rgba(200, 215, 235, 0.08)', borderRadius: '1px' }}
            animate={{ y: [-20, -500], rotate: [0, Math.random() * 30 - 15], opacity: [0.08, 0] }}
            transition={{ duration: 8 + Math.random() * 4, repeat: Infinity, delay: i * 0.5, ease: 'linear' }}
          />
        ))}
      </div>
      
      <div className="max-w-4xl mx-auto relative z-10">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="text-center mb-2">
          <h2 className="text-2xl sm:text-3xl md:text-4xl" style={{ fontFamily: 'Cinzel, serif', color: 'rgba(235, 240, 250, 0.95)', fontWeight: 400 }}>{novels.heading}</h2>
        </motion.div>
        
        <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.1 }} className="text-center mb-8 sm:mb-10 md:mb-12" style={{ fontFamily: 'DM Mono, monospace', color: 'rgba(150, 170, 200, 0.7)', fontSize: '0.85rem' }}>
          {novels.subtitle}
        </motion.p>
        
        <motion.div 
          initial={{ opacity: 0, y: 30 }} 
          whileInView={{ opacity: 1, y: 0 }} 
          viewport={{ once: true }} 
          transition={{ duration: 0.8 }}
          whileHover={{ scale: 1.01, y: -2 }}
          className="glass-panel p-6 sm:p-8 md:p-10 mb-6 sm:mb-8"
        >
          <h3 className="text-xl sm:text-2xl mb-2" style={{ fontFamily: 'Cinzel, serif', color: 'rgba(240, 245, 255, 0.95)', fontWeight: 500 }}>{novels.featuredNovel.title}</h3>
          <p className="mb-4 sm:mb-6 text-xs sm:text-sm" style={{ fontFamily: 'DM Mono, monospace', color: 'rgba(180, 200, 230, 0.85)', fontSize: '0.75rem' }}>{novels.featuredNovel.genre}</p>
          <p className="mb-4 sm:mb-6 text-sm sm:text-base" style={{ fontFamily: 'EB Garamond, serif', color: 'rgba(220, 230, 245, 0.9)', lineHeight: '1.85' }}>{novels.featuredNovel.mood}</p>
          <p className="text-sm sm:text-base" style={{ fontFamily: 'EB Garamond, serif', fontStyle: 'italic', color: 'rgba(180, 195, 220, 0.8)' }}>"{novels.featuredNovel.personalNote}"</p>
        </motion.div>
        
        <motion.div 
          initial={{ opacity: 0, y: 30 }} 
          whileInView={{ opacity: 1, y: 0 }} 
          viewport={{ once: true }} 
          transition={{ duration: 0.8, delay: 0.2 }}
          whileHover={{ scale: 1.01, y: -2 }}
          className="glass-panel p-6 sm:p-8 mb-6 sm:mb-8"
        >
          <p className="mb-3 sm:mb-4 text-xs sm:text-sm" style={{ fontFamily: 'DM Mono, monospace', color: 'rgba(150, 170, 200, 0.7)', fontSize: '0.8rem' }}>{novels.verse.title}</p>
          <blockquote className="pl-3 sm:pl-4 mb-3 sm:mb-4 text-base sm:text-lg" style={{ fontFamily: 'EB Garamond, serif', fontStyle: 'italic', color: 'rgba(220, 230, 245, 0.9)', lineHeight: '1.9', borderLeft: '2px solid rgba(180, 195, 220, 0.3)' }}>
            {novels.verse.content.split('\n').map((line, i) => (<span key={i}>{line}<br/></span>))}
          </blockquote>
          <p className="text-right text-xs sm:text-sm" style={{ fontFamily: 'DM Mono, monospace', color: 'rgba(150, 170, 200, 0.6)', fontSize: '0.75rem' }}>{novels.verse.attribution}</p>
        </motion.div>
        
        <motion.div 
          initial={{ opacity: 0, y: 30 }} 
          whileInView={{ opacity: 1, y: 0 }} 
          viewport={{ once: true }} 
          transition={{ duration: 0.8, delay: 0.3 }}
          whileHover={{ scale: 1.01, y: -2 }}
          className="glass-panel p-6 sm:p-8"
        >
          <p className="text-sm sm:text-base" style={{ fontFamily: 'EB Garamond, serif', color: 'rgba(220, 230, 245, 0.9)', lineHeight: '1.85' }}>{novels.philosophy}</p>
        </motion.div>
      </div>
    </section>
  );
};

export default NovelsSection;